// src/api/school.js
import request from '@/utils/request'

// api接口列表
const api = {
	type: 'major/list',
	list: 'major/children/list',
	detail: 'major/detail',
	employ: 'major/detail/employment',
	rank: 'major/rank',
	recommend: 'major/recommend',
	professionType: 'occupation/major',
	professionList: 'occupation/list',
	professionDetail: 'occupation/detail',
	occupationList: 'occupation/new/list'
}

// 专业左侧
export function type(params) {
	return request({
		url: api.type,
		method: 'get',
		params
	})
}

// 专业列表
export function list(params) {
	return request({
		url: api.list,
		method: 'get',
		params
	})
}

// 专业详情
export function detail(params) {
	return request({
		url: api.detail,
		method: 'get',
		params
	})
}

// 关于就业专业
export function employ(params) {
	return request({
		url: api.employ,
		method: 'get',
		params
	})
}

// 专业排名
export function rank(params) {
	return request({
		url: api.rank,
		method: 'get',
		params
	})
}

// 推荐专业
export function recommend(params) {
	return request({
		url: api.recommend,
		method: 'get',
		params
	})
}


// 职业左侧
export function professionType(params) {
	return request({
		url: api.professionType,
		method: 'get',
		params
	})
}

// 职业列表
export function professionList(params) {
	return request({
		url: api.professionList,
		method: 'get',
		params
	})
}

// 职业详情
export function professionDetail(params) {
	return request({
		url: api.professionDetail,
		method: 'get',
		params
	})
}

// 职业列表，和小程序一致
export function occupationList(params) {
	return request({
		url: api.occupationList,
		method: 'get',
		params
	})
}